export default __webpack_public_path__ + "locales/sr-Latn-RS/OAuth.json?hash=0aa2a59671e3614f2ccde33dd9355d76";